import React from 'react';

export const SvgCropExpanded169 = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 8a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h14a1 1 0 001-1V8zM4 5a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2H4z"
      fill="currentColor"
    />
  </svg>
);
